import { SDUISectionStyleWrapper } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/SDUISectionRenderer/SDUISectionStyleWrapper/SDUISectionStyleWrapper";
import { SDUISectionInstanceRendererProps } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/types";
import { FilterablePaginatedSectionContextProvider } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/FilterablePaginatedSectionContext";
import { FilterablePaginatedSectionWrapper } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/FilterablePaginatedSectionWrapper/FilterablePaginatedSectionWrapper";
import { SDUIFilterStoreProvider } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Filters/SDUIFilterStoreProvider";
import { SDUIFilterablePaginatedSectionPaginationNonRSC } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Pagination/SDUIFilterablePaginatedSectionPaginationNonRSC";
import { SDUIRetrievalQueriesNonRSC } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/RetrievalQueries/SDUIRetrievalQueriesNonRSC";
import { SDUIFilterablePaginatedSectionComponentsColumnNonRSC } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/SectionComponentsColumn/SDUIFilterablePaginatedSectionComponentsColumnNonRSC";
import { FilterablePaginatedSectionSideBarRendererNonRSC } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Sidebar/FilterablePaginatedSectionSideBarRendererNonRSC";
import { SDUIFPSRendererWithCollapsibleSidebarWrapper } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Sidebar/SDUIFPSRendererWithCollapsibleSidebarWrapper";
import { useSettingEnableVisualNavUpgrade } from "@faire/retailer-visitor-shared/settings/useSettingEnableVisualNavUpgrade";
import { DisplayPageType } from "@faire/web-api--source/indigofair/data/DisplayPageType";
import { IFilterablePaginatedSection } from "@faire/web-api--source/indigofair/data/IFilterablePaginatedSection";
import React from "react";

export const SDUIFilterablePaginatedSectionRenderer: React.FC<
  SDUISectionInstanceRendererProps
> = ({ section, ...rest }) => {
  const filterablePaginatedSection = section.filterable_paginated_section;
  if (filterablePaginatedSection) {
    return (
      <SDUISectionStyleWrapper sectionStyles={section.style}>
        <FilterablePaginatedSectionRenderer
          filterablePaginatedSection={filterablePaginatedSection}
          isPrimaryContent={section.is_required_for_interactivity}
          {...rest}
        />
      </SDUISectionStyleWrapper>
    );
  }
  return null;
};

const FilterablePaginatedSectionRenderer: React.FC<
  Omit<SDUISectionInstanceRendererProps, "section"> & {
    filterablePaginatedSection: IFilterablePaginatedSection;
    isPrimaryContent?: boolean;
  }
> = ({
  filterablePaginatedSection,
  componentRenderers,
  sectionLoggingData,
  isPrimaryContent,
  UPLTprops,
}) => {
  const isCategoryPage =
    sectionLoggingData.view_display_page === DisplayPageType.CATEGORY_PAGE;
  const enableCollapsibleFilterSidebar =
    useSettingEnableVisualNavUpgrade() && isCategoryPage;

  return (
    <FilterablePaginatedSectionContextProvider>
      <FilterablePaginatedSectionWrapper>
        <SDUIRetrievalQueriesNonRSC
          filterablePaginatedSection={filterablePaginatedSection}
        />
        <SDUIFilterStoreProvider
          filterablePaginatedSection={filterablePaginatedSection}
          enableCollapsibleFilterSidebar={enableCollapsibleFilterSidebar}
        >
          <SDUIFPSRendererWithCollapsibleSidebarWrapper
            sectionLoggingData={sectionLoggingData}
          >
            <FilterablePaginatedSectionSideBarRendererNonRSC
              filterablePaginatedSection={filterablePaginatedSection}
              sectionLoggingData={sectionLoggingData}
            />
            <SDUIFilterablePaginatedSectionComponentsColumnNonRSC
              filterablePaginatedSection={filterablePaginatedSection}
              componentRenderers={componentRenderers}
              sectionLoggingData={sectionLoggingData}
              isPrimaryContent={isPrimaryContent}
              UPLTprops={UPLTprops}
            />
          </SDUIFPSRendererWithCollapsibleSidebarWrapper>
          <SDUIFilterablePaginatedSectionPaginationNonRSC
            filterablePaginatedSection={filterablePaginatedSection}
            sectionLoggingData={sectionLoggingData}
          />
        </SDUIFilterStoreProvider>
      </FilterablePaginatedSectionWrapper>
    </FilterablePaginatedSectionContextProvider>
  );
};
